import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded';
import PostRail from '../shared/PostRail';
import { SectionCard } from '../shared/insightUi';

export default function RecentPosts({ recent_posts = [] }) {
  const posts = (Array.isArray(recent_posts) ? recent_posts : []).slice(0, 30);
  if (!posts.length) return null;
  return (
    <SectionCard
      icon={<ScheduleRoundedIcon fontSize="small" />}
      title="Recent posts"
      subtitle="Latest content published on this profile"
      bodyPadding="16px 24px 12px"
    >
      <PostRail posts={posts} />
    </SectionCard>
  );
}
